import React, { useEffect, useState } from "react";
import { ClockCircleOutlined, UserOutlined } from "@ant-design/icons";
import {
  getListeFichierMissionClient,
  supprimerFileMission,
} from "../../../../data/file";
import FileUploaderMission from "../upload/FileUploaderMission";
import { cleanAndNormalizeName } from "../../../utilities/Utilities";
import { DOWNLOAD_FILE_CLIENT } from "../../../../api/apiRoutes";
import { getIconForFileType } from "../../../layout/menu/CustomMenu";
import moment from "moment/moment";
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Input,
  notification,
  Popconfirm,
  Popover,
  Select,
  Space,
  Table,
  Tag,
  Tooltip,
} from "antd";
import { FormContainer, TagItem } from "../../../common/common.components";
import { appTheme } from "../../../../config/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCloudUpload,
  faCopy,
  faDownload,
  faExclamationCircle,
  faFileEdit,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { ModalTitle } from "../../../modals/modals.components";
import ModalAlert from "../../../modals/Modal";
import FormLabel from "../../../common/Form/FormLabel";
import SearchRow from "../../../common/SearchRow";
import TableTitle from "../../../common/TableTitle";
import { getListeSommaireActive } from "../../../../data/params/sommaire";
import useUsers from "../../../../hooks/users/useUser";
import swal from "sweetalert";
import { CopyFileSommaire, ModifyFichier } from "../../../modals/ModalFichier";

const ListeFileMission = ({
  client,
  mission,
  isSommaireAdd,
  handleVisibility,
  visible,
  chargement,
}) => {
  const users = useUsers();
  const [filtersItems, setFiltersItems] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalId, setModalId] = useState(null);
  const [file, setFile] = useState(null);
  const [sommairesTable, setSommairesTable] = useState([]);

  const [paramsRecherche, setParamsRecherche] = useState({
    codeSommaire: "",
    infoFile: "",
    user_id: "",
    date_debut: "",
    date_fin: "",
  });

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 5,
    },
  });

  const fetchSommaire = () => {
    getListeSommaireActive().then((res) => {
      setSommairesTable(res.result);
    });
  };

  useEffect(() => {
    fetchSommaire();
  }, []);

  useEffect(() => {
    if (mission) {
      fetchDocumentsClient(mission.id);
    }
  }, [mission]);

  const fetchDocumentsClient = async (id) => {
    setLoading(true);
    getListeFichierMissionClient(id).then((res) => {
      setDocuments(
        res.result.sort((p1, p2) => {
          return new Date(p2.createdAt) - new Date(p1.createdAt);
        })
      );
      setFiltersItems(
        res.result.sort((p1, p2) => {
          return new Date(p2.createdAt) - new Date(p1.createdAt);
        })
      );
      setLoading(false);
    });
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });

    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setDocuments([]);
    }
  };

  const downloadDocumentsClient = (client_bog, client_lea, fichier) => {
    setLoading(true);
    setTimeout(() => {
      const clientBogName = cleanAndNormalizeName(client_bog);
      const clientName = cleanAndNormalizeName(client_lea);
      const missionName = cleanAndNormalizeName(mission.mission);
      // ${clientBogName}/${clientName}/${exercice.annee}/${missionName}`
      window.open(
        `${DOWNLOAD_FILE_CLIENT}/${clientBogName}/${clientName}/${mission.annee}/${missionName}/${fichier}`,
        "_blank"
      );

      setLoading(false);
      notification.success({
        description: "Télécharger avec succès",
      });
    }, 1500);
  };

  const handleDeleteFileSommaire = (file_id) => {
    setLoading(true);
    const data = {
      file_id,
    };
    supprimerFileMission(data)
      .then(async (res) => {
        const { status, message } = res;
        if (status === "success") {
          setLoading(false);
          fetchDocumentsClient(mission.id);
          await swal(`Opération effectuée avec succès`, "", "success");
        } else {
          await swal(message, "", "error");
          setLoading(false);
        }
      })
      .catch((err) => {
        notification.error({
          description: err,
        });
      });
  };

  const handleModalOpen = (modal_id, file) => {
    setModalId(modal_id);

    setFile(file);
    setIsModalOpen((prevState) => !prevState);
  };

  const columns = [
    {
      title: () => <TableTitle>#</TableTitle>,
      render: (_, record, index) => <>{index + 1}</>,
      width: 40,
    },
    {
      title: () => <TableTitle>Sommaire</TableTitle>,
      dataIndex: "codeSommaire",
      render: (_, record) => (
        <Tag color={appTheme.colors.primary_blue}>{record.codeSommaire}</Tag>
      ),
    },
    {
      title: () => <TableTitle>Reference</TableTitle>,
      dataIndex: "reference",
      render: (_, record) => <TagItem>{record.reference}</TagItem>,
    },
    {
      title: () => <TableTitle>Document</TableTitle>,
      dataIndex: "libelle",
      render: (_, record) => (
        <div className="d-flex align-items-center">
          <span className="svg-icon svg-icon-2x svg-icon-primary me-4">
            {getIconForFileType(record.extension || record.libelle)}
          </span>
          <div
            style={{
              fontFamily: "Oswald, sans-serif",
              fontSize: "12px",
              fontWeight: "700",
            }}
          >
            {record.libelle}
          </div>
        </div>
      ),
    },
    {
      title: () => <TableTitle>Taille (KO)</TableTitle>,
      dataIndex: "size",
      render: (_, record) => (
        <TagItem>{(record.size / 1024).toFixed(2)}</TagItem>
      ),
    },
    {
      title: () => <TableTitle>Dernière modif.</TableTitle>,
      dataIndex: "modif",
      render: (_, record) => (
        <div className="d-flex flex-column align-center">
          <span
            className="chart-orange display-block f-size-12 pe-5"
            style={{ fontWeight: 600, fontSize: "11px" }}
          >
            <UserOutlined style={{ fontSize: "15px" }} />{" "}
            {record.Lea_User?.nom_user + " " + record.Lea_User?.prenom_user}
          </span>
          <span
            className="chart-blue display-block f-size-12"
            style={{ fontWeight: 600 }}
          >
            <ClockCircleOutlined style={{ fontSize: "12px" }} />{" "}
            {moment(record.updatedAt).format("DD/MM/YYYY à HH:mm")}
          </span>
        </div>
      ),
    },
    {
      title: () => <TableTitle>Dossier client</TableTitle>,
      dataIndex: "dossiers",
      render: () => (
        <div className="d-flex flex-column">
          <span style={{ color: "#000", fontWeight: "bold", fontSize: "12px" }}>
            {mission.denomination}
          </span>
          <span
            className="text-gray-800 fw-bold text-hover-primary mb-1"
            style={{ fontSize: "12px" }}
          >
            {mission.mission}{" "}
            <span className="ms-3">
              {mission.annee && (
                <TagItem color={appTheme.colors.primary}>
                  {mission.annee}
                </TagItem>
              )}
            </span>
          </span>
        </div>
      ),
    },
    {
      title: () => <TableTitle>Notes</TableTitle>,
      dataIndex: "description",
      render: (_, record) => (
        <>
          {record.description && (
            <Popover
              placement="top"
              title="Notes"
              content={
                <>
                  <Divider />
                  <span
                    style={{
                      fontFamily: "Oswald, sans-serif",
                      fontSize: "13px",
                    }}
                  >
                    {record.description}
                  </span>
                </>
              }
            >
              <Button
                icon={<FontAwesomeIcon icon={faExclamationCircle} />}
                color={""}
              />
            </Popover>
          )}
        </>
      ),
    },
    {
      title: () => <TableTitle>Actions</TableTitle>,
      dataIndex: "action",
      render: (_, record) => (
        <Space>
          <Tooltip
            color={appTheme.colors.primary}
            title="Téléchager le fichier"
          >
            <Button
              shape="circle"
              size={"middle"}
              style={{ backgroundColor: appTheme.colors.primary }}
              onClick={() =>
                downloadDocumentsClient(
                  record.Bog_Client?.nom_cabinet,
                  record.Lea_Client?.denomination,
                  record.fichier
                )
              }
              icon={<FontAwesomeIcon icon={faDownload} color={"white"} />}
            />
          </Tooltip>
          {(mission.isCloture !== 1 || mission.isClotureProvisoire !== 1) && (
            <>
              <Tooltip title="Faire une copie dans le dossier permanent">
                <Button
                  shape="circle"
                  size={"middle"}
                  style={{}}
                  onClick={() => handleModalOpen(3, record)}
                  icon={<FontAwesomeIcon icon={faCopy} color={""} />}
                />
              </Tooltip>
              <Tooltip
                color={appTheme.colors.primary}
                title="Modifier les informations du fichiers"
              >
                <Button
                  shape="circle"
                  size={"middle"}
                  style={{ backgroundColor: "" }}
                  onClick={() => handleModalOpen(2, record)}
                  icon={
                    <FontAwesomeIcon
                      icon={faFileEdit}
                      color={appTheme.colors.primary_blue}
                    />
                  }
                />
              </Tooltip>
              <Tooltip title="Supprimer ce fichier">
                <Popconfirm
                  title="Confirmer la suppression de ce fichier"
                  description="Voulez-vous supprimer ce fichier?"
                  onConfirm={() => handleDeleteFileSommaire(record.id)}
                >
                  <Button
                    shape="circle"
                    size={"middle"}
                    style={{ backgroundColor: "red" }}
                    icon={<FontAwesomeIcon icon={faTrash} color={"white"} />}
                  />
                </Popconfirm>
              </Tooltip>
            </>
          )}
        </Space>
      ),
    },
  ];

  const handleSearch = () => {
    setLoading(true);

    setTimeout(() => {
      const filteredClients = documents.filter((file) => {
        const referenceMatch = file.reference
          ?.toLowerCase()
          .includes(paramsRecherche?.infoFile.toLowerCase());
        const libelleMatch = file.libelle
          ?.toLowerCase()
          .includes(paramsRecherche?.infoFile.toLowerCase());
        const descriptionMatch = file.description
          ?.toLowerCase()
          .includes(paramsRecherche?.infoFile.toLowerCase());
        const userMatch =
          paramsRecherche.user_id === "" ||
          file.Lea_User?.id === paramsRecherche.user_id;
        const codeSommaireMatch =
          paramsRecherche.codeSommaire === "" ||
          file.codeSommaire === paramsRecherche.codeSommaire;
        const createdAtMatch =
          (paramsRecherche.date_debut === "" &&
            paramsRecherche.date_fin === "") ||
          moment(file.createdAt).isBetween(
            moment(paramsRecherche.date_debut),
            moment(paramsRecherche.date_fin)
          );

        return (
          (referenceMatch || descriptionMatch || libelleMatch) &&
          userMatch &&
          codeSommaireMatch &&
          createdAtMatch
        );
      });

      setFiltersItems(filteredClients);
      setLoading(false);
    }, 1000);
  };

  const handleReset = () => {
    setLoading(true);
    setParamsRecherche({
      codeSommaire: "",
      infoFile: "",
      user_id: "",
      date_debut: "",
      date_fin: "",
    });
    setFiltersItems(documents);
    setLoading(false);
  };

  return (
    <>
      <ModalAlert
        closeModal={handleVisibility}
        show={visible}
        title={
          <ModalTitle>
            {" "}
            Liste des documents{" "}
            {mission
              ? `de ${mission.mission || ""} - ${mission.annee || ""}`
              : ""}
          </ModalTitle>
        }
        footer={[]}
        modalStyles={{ top: 15 }}
        width={1200}
      >
        <SearchRow
          handleSearch={handleSearch}
          handleReset={handleReset}
          loading={loading}
        >
          <Col
            xs={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 6 }}
            xl={{ span: 6 }}
          >
            <FormLabel label="Fichier" />
            <Input
              style={{ width: "100%" }}
              size="middle"
              placeholder="Reference ou libellé ou description"
              // value={paramsRecherche.infoClient}
              onChange={(e) =>
                setParamsRecherche({
                  ...paramsRecherche,
                  infosClient: e.target.value,
                })
              }
            />
          </Col>
          <Col
            xs={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 6 }}
            xl={{ span: 6 }}
          >
            <FormLabel label="Sommaire" />
            <Select
              placeholder="Code du sommaire"
              size="middle"
              style={{ width: "100%" }}
              onSelect={(value) =>
                setParamsRecherche({ ...paramsRecherche, codeSommaire: value })
              }
              options={sommairesTable.map((statut) => ({
                value: statut.libelle,
                label: `${statut.libelle} - ${statut.description}`,
              }))}
            />
          </Col>
          <Col
            xs={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 6 }}
            xl={{ span: 6 }}
          >
            <FormLabel label="Utilisateurs" />
            <Select
              placeholder="Utilisateur"
              size="middle"
              style={{ width: "100%" }}
              onSelect={(value) =>
                setParamsRecherche({ ...paramsRecherche, user_id: value })
              }
              options={
                users &&
                users.users.map((user) => ({
                  value: user.id,
                  label: `${
                    user.initial || ""
                  } - ${user.nom_user.toUpperCase()} ${
                    user.prenom_user ? user.prenom_user.toUpperCase() : ""
                  }`,
                }))
              }
            />
          </Col>
          <Col
            xs={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 6 }}
            xl={{ span: 6 }}
          >
            <FormLabel label="Date debut" />
            <DatePicker
              size="middle"
              placeholder="Date début de la création"
              style={{ width: "100%" }}
              allowClear
              onChange={(date, dateString) =>
                date !== null
                  ? setParamsRecherche({
                      ...paramsRecherche,
                      date_debut: date.format("YYYY-MM-DD"),
                    })
                  : setParamsRecherche({ ...paramsRecherche, date_debut: "" })
              }
              format={["DD-MM-YYYY", "YYYY-MM-DD"]}
            />
          </Col>
          <Col
            xs={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 6 }}
            xl={{ span: 6 }}
          >
            <FormLabel label="Date fin" />
            <DatePicker
              size="middle"
              placeholder="Date fin  de la création"
              style={{ width: "100%" }}
              allowClear
              onChange={(date, dateString) =>
                date !== null
                  ? setParamsRecherche({
                      ...paramsRecherche,
                      date_fin: date.format("YYYY-MM-DD"),
                    })
                  : setParamsRecherche({ ...paramsRecherche, date_fin: "" })
              }
              format={["DD-MM-YYYY", "YYYY-MM-DD"]}
            />
          </Col>
        </SearchRow>
        <FormContainer>
          <div className="w-100">
            {mission.isCloture !== 1 && (
              <div className="d-flex justify-content-end align-center my-2 me-5">
                <Tooltip
                  color={appTheme.colors.primary}
                  title="Importer un fichier pour l'exercice"
                >
                  <Button
                    size={"middle"}
                    style={{ backgroundColor: appTheme.colors.primary }}
                    onClick={() => handleModalOpen(1)}
                    icon={
                      <FontAwesomeIcon icon={faCloudUpload} color={"white"} />
                    }
                  >
                    Importer
                  </Button>
                </Tooltip>
              </div>
            )}
            <div className="py-4">
              <div className="table-responsive">
                <Table
                  columns={columns}
                  rowKey={(record) => record.id}
                  dataSource={filtersItems}
                  pagination={tableParams.pagination}
                  loading={loading || chargement}
                  onChange={handleTableChange}
                  rowSelection
                  size={"small"}
                />
              </div>
            </div>
          </div>
        </FormContainer>
        {isModalOpen && modalId === 1 && (
          <FileUploaderMission
            handleVisibility={handleModalOpen}
            data={client}
            mission={mission}
            visible={isModalOpen}
            isSommaireAdd={isSommaireAdd}
            chargement={loading || chargement}
            fetchData={fetchDocumentsClient}
          />
        )}
        {isModalOpen && modalId === 2 && (
          <ModifyFichier
            handleVisibility={handleModalOpen}
            file={file}
            mission={mission}
            // codeSommaire={codeSommaire}
            visible={isModalOpen}
            chargement={loading}
            fetchData={fetchDocumentsClient}
          />
        )}
        {isModalOpen && modalId === 3 && (
          <CopyFileSommaire
            handleVisibility={handleModalOpen}
            file={file}
            mission={mission}
            // codeSommaire={}
            visible={isModalOpen}
            chargement={loading}
            fetchData={fetchDocumentsClient}
          />
        )}
      </ModalAlert>
    </>
  );
};

export default ListeFileMission;
